import { createContext, useContext, useState } from "react";

const ImpersonationContext = createContext(null);

export function AppLayoutProvider({ children }) {
    const [impersonated, setImpersonate] = useState(null);

    return (
        <ImpersonationContext.Provider value={{ impersonated, setImpersonate }}>
            {children}
        </ImpersonationContext.Provider>
    );
}

export function useImpersonation() {
    const { impersonated, setImpersonate } = useContext(ImpersonationContext);

    return [impersonated, setImpersonate];
}
